import { ComponentStyleConfig } from '@chakra-ui/react';

export const SettingsPageList: ComponentStyleConfig = {
  parts: ['container', 'textWrapper', 'primaryText', 'secondaryText'],
  baseStyle: ({ isMobile, minButtonWidth = '88px' }) => ({
    container: {
      display: 'inline-flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      w: 'full',
    },
    textWrapper: {
      minHeight: '44px',
      alignSelf: 'flex-start',
      pr: 2,
      maxWidth: isMobile ? `calc(100% - ${minButtonWidth})` : '100%',
    },
    primaryText: {
      fontSize: 'sm',
      color: 'M.70',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      textDecoration: 'none',
    },
    secondaryText: {
      fontSize: 'xs',
      fontWeight: 400,
      color: 'M.60',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
  }),
  sizes: {},
  variants: {},
  defaultProps: {},
};
